import { render, staticRenderFns } from "./edit-dialog.vue?vue&type=template&id=502d5043&scoped=true"
import script from "./edit-dialog.vue?vue&type=script&lang=js"
export * from "./edit-dialog.vue?vue&type=script&lang=js"
import style0 from "./edit-dialog.vue?vue&type=style&index=0&id=502d5043&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502d5043",
  null
  
)

export default component.exports